import { HarborClientModule } from "@pharaday/api";
import { AuthModule } from "@pharaday/auth";
import { EnvVariablesModule } from "@pharaday/env";
import { Container } from "inversify";
import "reflect-metadata";

import { NavigationModule } from "./infrastructure/navigation.module";
import { OrganizationProfileModule } from "./infrastructure/organization-profile.module";
import { UserModule } from "./infrastructure/user.module";

export const AuthenticatedContainer = new Container({ defaultScope: "Singleton" });

AuthenticatedContainer.load(
  EnvVariablesModule,
  HarborClientModule,
  AuthModule,
  NavigationModule,
  UserModule,
  OrganizationProfileModule
);
